(function () {
  const heroes = document.querySelectorAll('[data-holy-hero]');
  if (!heroes.length) return;

  heroes.forEach((hero) => {
    const slides = [...hero.querySelectorAll('[data-holy-hero-slide]')];
    if (slides.length < 2) return;

    const duration = Number(hero.dataset.slideDuration || 6000);
    const fills = [...hero.querySelectorAll('[data-holy-hero-progress]')];
    const labels = [...hero.querySelectorAll('[data-holy-hero-label]')];
    let index = 0;
    let timer;

    const setSlide = (next) => {
      slides[index].classList.remove('is-active');
      if (fills[index]) fills[index].classList.remove('is-active');
      index = next;
      slides[index].classList.add('is-active');
      if (fills[index]) fills[index].classList.add('is-active');
      if (labels.length) {
        labels.forEach((el, i) => el.classList.toggle('is-active', i === index));
      }
    };

    const tick = () => {
      setSlide((index + 1) % slides.length);
      timer = window.setTimeout(tick, duration);
    };

    slides[0].classList.add('is-active');
    if (fills[0]) fills[0].classList.add('is-active');
    if (labels[0]) labels[0].classList.add('is-active');

    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!reduced) timer = window.setTimeout(tick, duration);

    hero.querySelectorAll('[data-holy-hero-dot]').forEach((dot) => {
      dot.addEventListener('click', () => {
        const target = Number(dot.dataset.holyHeroDot);
        if (Number.isNaN(target) || target === index) return;
        window.clearTimeout(timer);
        setSlide(target);
        if (!reduced) timer = window.setTimeout(tick, duration);
      });
    });
  });
})();
